interface UseConditionalRenderProps {
  isFetching: boolean;
  data: any[] | undefined;
}

interface UseConditionalRenderReturn {
  shouldRender: boolean;
  hasData: boolean;
}

export const useConditionalRender = ({
  isFetching,
  data,
}: UseConditionalRenderProps): UseConditionalRenderReturn => {
  const hasData = data && data.length > 0;
  const shouldRender = isFetching || !!hasData;

  return {
    shouldRender,
    hasData: !!hasData,
  };
};
